function lang (state = {
  lang: 'cn',
}, action) {
  switch(action.type) {
    case 'SWITCH_LANG':
      return {
        lang: action.data,
      }
    default:
      return state;
  }
}

export default lang;


// WEBPACK FOOTER //
// ./src/reducer/action/lang.js